module.exports = __webpack_public_path__ + "media/images/icons/google_white-d57e50bd17d7f5d820c0626ec1190b71.svg";